import { FunctionComponent } from 'react';
import { twMerge } from 'src/utils/twMerge';
import { projectColors } from 'src/styles/project-styles';
import { hexToRgba } from 'src/utils/hexaToRgba';

type Props = {
  value: number;
  height?: number;
  color?: string;
  backgroundColor?: string;
  className?: string;
  fillClassName?: string;
  isStyledByClass?: boolean;
  animated?: boolean;
  stripes?: boolean;
  'data-testid'?: string;
};

const Progress: FunctionComponent<Props> = ({
  value,
  height = 8,
  color = projectColors.white,
  backgroundColor = hexToRgba(projectColors.white, 0.2),
  className = '',
  fillClassName,
  isStyledByClass = false,
  animated = true,
  stripes = false,
  'data-testid': dataTestId,
}) => {
  const clampedValue = Math.min(Math.max(0, value), 100);

  return (
    <div
      className={twMerge(
        'overflow-hidden',
        !isStyledByClass && 'rounded-xl',
        className,
      )}
      style={
        isStyledByClass
          ? undefined
          : { backgroundColor: backgroundColor, height: `${height}px` }
      }
      data-testid={dataTestId}
      role="progressbar"
      aria-valuenow={Math.round(clampedValue)}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div
        className={twMerge(
          'h-full',
          !isStyledByClass && 'rounded-lg',
          animated && 'transition-all duration-lg ease-out',
          stripes && 'relative animate-barberpole',
          fillClassName,
        )}
        style={{
          width: `${clampedValue}%`,
          ...(!isStyledByClass && { backgroundColor: color }),
          ...(stripes && {
            backgroundImage: `repeating-linear-gradient(-30deg, transparent, transparent 18px, ${projectColors.warning.light} 18px, ${projectColors.warning.light} 25px)`,
          }),
        }}
      />
    </div>
  );
};

export default Progress;
